export const SENTRY_URL = 'https://71cdbbd595957139a979c67071aa1132@o4508368252174336.ingest.de.sentry.io/4511896399904848';

export const INVESTOR_PORTAL_SESSION_ID_TAG_KEY = 'investor_portal_session_id';
export const INVESTOR_PORTAL_COMPONENT_TAG = 'investor-portal';
